/* Bigalli · Liquidación de Verano
   1) Filtro de materialidad del grid (client-side, sin recarga)
   2) Cuenta atrás de cierre de temporada
   Se auto-inicializa y es idempotente (seguro en el editor de temas). */

(function () {
  'use strict';

  /* ---------- Filtro de materialidad ---------- */
  function initFilter(root) {
    if (!root || root.dataset.bgFilterReady === 'true') return;
    root.dataset.bgFilterReady = 'true';

    var buttons = root.querySelectorAll('[data-bg-filter]');
    var gridId = root.getAttribute('data-bg-target');
    var grid = gridId ? document.getElementById(gridId) : root.parentElement.querySelector('[data-bg-grid]');
    if (!buttons.length || !grid) return;

    var countEl = document.querySelector('[data-bg-count="' + (gridId || '') + '"]');
    var labelEl = document.querySelector('[data-bg-filter-label="' + (gridId || '') + '"]');

    function apply(value, label) {
      var cards = grid.querySelectorAll('[data-bg-material]');
      var shown = 0;
      cards.forEach(function (card) {
        var match = value === '*' || card.getAttribute('data-bg-material') === value;
        card.classList.toggle('bg-card--hidden', !match);
        if (match) shown++;
      });
      if (countEl) {
        countEl.textContent = shown + (shown === 1 ? ' pieza' : ' piezas');
      }
      if (labelEl && label) {
        labelEl.textContent = value === '*' ? labelEl.getAttribute('data-bg-default') || label : 'Solo ' + label;
      }
      buttons.forEach(function (b) {
        b.setAttribute('aria-selected', String(b.getAttribute('data-bg-filter') === value));
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-bg-filter'), btn.textContent.trim());
      });
    });

    var initial = root.querySelector('[data-bg-filter][aria-selected="true"]') || buttons[0];
    apply(initial.getAttribute('data-bg-filter'), initial.textContent.trim());
  }

  /* ---------- Cuenta atrás ---------- */
  function initCountdown(root) {
    if (!root || root.dataset.bgCountReady === 'true') return;
    var iso = root.getAttribute('data-bg-deadline');
    if (!iso) return;
    var end = new Date(iso).getTime();
    if (isNaN(end)) return;
    root.dataset.bgCountReady = 'true';

    var slots = {
      days: root.querySelector('[data-bg-unit="days"]'),
      hours: root.querySelector('[data-bg-unit="hours"]'),
      minutes: root.querySelector('[data-bg-unit="minutes"]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        root.setAttribute('data-bg-expired', 'true');
        if (slots.days) slots.days.textContent = '00';
        if (slots.hours) slots.hours.textContent = '00';
        if (slots.minutes) slots.minutes.textContent = '00';
        clearInterval(timer);
        return;
      }
      var mins = Math.floor(diff / 60000);
      if (slots.days) slots.days.textContent = pad(Math.floor(mins / 1440));
      if (slots.hours) slots.hours.textContent = pad(Math.floor((mins % 1440) / 60));
      if (slots.minutes) slots.minutes.textContent = pad(mins % 60);
    }

    tick();
    var timer = setInterval(tick, 30000);
  }

  /* ---------- Carrusel ---------- */
  function initCarousel(root) {
    if (!root || root.dataset.bgCarouselReady === 'true') return;
    var rail = root.querySelector('[data-bg-rail]');
    if (!rail) return;
    root.dataset.bgCarouselReady = 'true';

    var prev = root.querySelector('[data-bg-prev]');
    var next = root.querySelector('[data-bg-next]');
    var bar = root.querySelector('[data-bg-progress-fill]');
    var autoplayMs = parseInt(root.getAttribute('data-bg-autoplay') || '0', 10);

    function step() {
      var card = rail.querySelector(':scope > *');
      if (!card) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
      var per = Math.max(1, Math.floor(rail.clientWidth / (card.offsetWidth + gap)));
      return (card.offsetWidth + gap) * per;
    }

    function maxScroll() { return Math.max(0, rail.scrollWidth - rail.clientWidth); }

    function sync() {
      var max = maxScroll();
      var pos = rail.scrollLeft;
      if (bar) bar.style.width = (max <= 1 ? 100 : Math.min(100, (pos / max) * 100 || 0)) + '%';
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
      root.classList.toggle('bg-carousel--static', max <= 1);
    }

    function go(dir) {
      var max = maxScroll();
      var target = rail.scrollLeft + dir * step();
      if (dir > 0 && rail.scrollLeft >= max - 2) target = 0;      // vuelve al inicio
      if (dir < 0 && rail.scrollLeft <= 2) target = max;          // salta al final
      rail.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); pause(); });
    if (next) next.addEventListener('click', function () { go(1); pause(); });

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });

    // Arrastre con puntero (desktop): el táctil ya usa scroll nativo
    var down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.classList.add('bg-rail--dragging');
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = startLeft - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        down = false;
        rail.classList.remove('bg-rail--dragging');
      });
    });
    rail.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); moved = false; }
    }, true);

    // Teclado
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); pause(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); pause(); }
    });

    // Autoplay opcional, respetuoso con el usuario
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function play() {
      if (!autoplayMs || reduced || timer) return;
      timer = setInterval(function () { go(1); }, autoplayMs);
    }
    function pause() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    if (autoplayMs && !reduced) {
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', pause);
      rail.addEventListener('touchstart', pause, { passive: true });
      document.addEventListener('visibilitychange', function () {
        document.hidden ? pause() : play();
      });
      play();
    }

    window.addEventListener('resize', function () { window.requestAnimationFrame(sync); });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    sync();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-bg-filter-bar]').forEach(initFilter);
    (scope || document).querySelectorAll('[data-bg-deadline]').forEach(initCountdown);
    (scope || document).querySelectorAll('[data-bg-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Recargas de sección en el editor de temas
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
